import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Col1Component } from '../../../components/home-templates/col-1/col-1.component';
import { Col21Component } from '../../../components/home-templates/col-21/col-21.component';
import { Col31Component } from '../../../components/home-templates/col-31/col-31.component';
import { Col421Component } from '../../../components/home-templates/col-421/col-421.component';
import { Col632Component } from '../../../components/home-templates/col-632/col-632.component';
import { Col213Component } from '../../../components/home-templates/col-2-1-3/col-2-1-3.component';
import { Col231Component } from '../../../components/home-templates/col-2-3-1/col-2-3-1.component';
import { Col212Component } from '../../../components/home-templates/col-2-1-2/col-2-1-2.component';
import { Col221Component } from '../../../components/home-templates/col-2-2-1/col-2-2-1.component';
import { Col3112Component } from '../../../components/home-templates/col-3-1-1-2/col-3-1-1-2.component';
import { Col3211Component } from '../../../components/home-templates/col-3-2-1-1/col-3-2-1-1.component';
import { Col3121Component } from '../../../components/home-templates/col-3-1-2-1/col-3-1-2-1.component';
import { HomeComponentsSharedModule } from '../home-components-shared/home-components-shared.module';

@NgModule({
  imports: [CommonModule, HomeComponentsSharedModule],
  declarations: [
    Col1Component,
    Col21Component,
    Col31Component,
    Col421Component,
    Col632Component,
    Col213Component,
    Col231Component,
    Col212Component,
    Col221Component,
    Col3112Component,
    Col3211Component,
    Col3121Component,
  ],
  exports: [
    Col1Component,
    Col21Component,
    Col31Component,
    Col421Component,
    Col632Component,
    Col213Component,
    Col231Component,
    Col212Component,
    Col221Component,
    Col3112Component,
    Col3211Component,
    Col3121Component,
  ],
})
export class ColumnsSharedModule {}
